import type { ModuleStorage } from "app/pages/sales-intelligence/services/storage/types";

import type { EducationBarConfig, EducationBarStorage } from "./types";

export default function createEducationBarStorage(
    storage: ModuleStorage,
    config: EducationBarConfig = { isOpenByDefault: true },
): EducationBarStorage {
    const STORAGE_KEY = "is-education-bar-shown";

    return {
        getEducationBarIsVisible() {
            return (storage.retrieve(STORAGE_KEY) as boolean) ?? config.isOpenByDefault;
        },
        setEducationBarIsVisible(isVisible: boolean) {
            storage.persist(STORAGE_KEY, isVisible);
        },
    };
}
